"use strict";

Core.Asset = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/asset',
    editGroupPermission: 'admin_assets',

    defaults: function() {
        return {
            active: true,
            documents: [],
            labels: []
        };
    },

    isStateAlterable: function() {
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        return this.isNew() || Core.client.hasPermission('edit_all_data') || Core.client.hasGroupPermission(this.get('groupId'), 'alter_asset_state');
    },

    isDispatchable: function() {
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        return this.isNew() || Core.client.hasPermission('edit_all_data') || Core.client.hasGroupPermission(this.get('groupId'), 'dispatch_assets');
    },

    hasTellusRequirements: function() {
        var meta = this.get('meta') ? JSON.parse(this.get('meta')) : null;
        return !!(meta && meta.tellusCompanyId && this.get('vin') && this.get('manufacturer'));
    },

    tellusIconClass: function() {
        if (!this.hasTellusRequirements()) return null;
        return this.get('tellus') ? 'icon icon-green icon-leaf' : 'icon icon-red icon-leaf';
    },

    setAssetType: function(assetType, options) {
        if (assetType) {
            this.set({
                assetTypeId: assetType.id,
                assetTypeName: assetType.get('name')
            }, options);
        } else {
            this.set({
                assetTypeId: null,
                assetTypeName: null
            }, options);
        }
    },

    setAttachedAsset: function(attachedAsset, options) {
        var self = this;
        var location = self.get('location');
        var locationDescription = self.get('locationDescription');
        var customFields = self.get('customFields');
        var assetType = Core.client.assetTypes.get(self.get('assetTypeId'));

        if (attachedAsset) {
            var attachedAssetCustomFields = attachedAsset.get('customFields').filter(function(customField) {
                if (customField.name === 'contractUsageStart' || customField.name === 'contractUsageEnd') return false;
                else return true;
            });
            
            if (attachedAssetCustomFields && customFields) {
                var commonCustomFields = [];
                var uncommonCustomFields = [];

                /* find common and uncommon custom fields */
                $.grep(attachedAssetCustomFields, function(attachedCustomField) {
                    var uncommon = customFields.filter(function(customField) {
                        return attachedCustomField.name === customField.name;
                    }).length == 0
                    uncommon ? uncommonCustomFields.push(attachedCustomField) : commonCustomFields.push(attachedCustomField);
                });

                /* update common custom fields */
                commonCustomFields.forEach(function(commonCustomField) {
                    customFields.forEach(function(customField) {
                        if (customField.name === commonCustomField.name)
                            customField.value = commonCustomField.value;
                    });
                });

                /* append uncommon custom fields */
                customFields.push.apply(customFields, uncommonCustomFields);
            } else {
                customFields = attachedAssetCustomFields;
            }
            
            if (attachedAsset.get('location')) location = attachedAsset.get('location');
            if (attachedAsset.get('locationDescription')) locationDescription = attachedAsset.get('locationDescription');

            if (assetType && assetType.get && assetType.get('assetTemplate')) {
                var assetTemplate = assetType.get('assetTemplate');
                if (attachedAssetCustomFields) {
                    if (assetTemplate.customFields.length == 0) {
                        /* no existing asset fields at all? */
                        attachedAssetCustomFields.forEach(function(attachedAssetCustomField) {
                            var attachedFieldClone = JSON.parse(JSON.stringify(attachedAssetCustomField));  // magic to avoid backend serializing issues
                            attachedFieldClone.value = null;
                            assetTemplate.customFields.push(attachedFieldClone);
                        });
                        assetType.save();
                    } else {
                        /* only interested in uncommon as we don't need to update any values */
                        var uncommonCustomFields = [];
                        var assetTypeTemplateCustomFields = assetTemplate.customFields;
                        $.grep(attachedAssetCustomFields, function(attachedCustomField) {
                            var uncommon = assetTypeTemplateCustomFields.filter(function(templateCustomField) {
                                return attachedCustomField.name === templateCustomField.name
                            }).length == 0;
                            if (uncommon) uncommonCustomFields.push(attachedCustomField);
                        });
    
                        var added = false;
                        if (uncommonCustomFields) {
                            uncommonCustomFields.forEach(function(uncommonCustomField) {
                                var attachedFieldClone = JSON.parse(JSON.stringify(uncommonCustomField));   // magic to avoid backend serializing issues
                                attachedFieldClone.value = null;
                                assetTemplate.customFields.push(attachedFieldClone);
                                added = true;
                            });
                        }
                        if (added) assetType.save();
                    }
                }
            }
            
            /* attempt to fix the sandwiched header */
            // var header = customFields.find(function(customField) {
            //     if (customField.name === 'trackUnitHeader' && customField.type === 'HEADER') return customField;
            // });
            // if (header) {
            //     customFields.splice(customFields.indexOf(header), 1);
            //     for (var i = 0; i < customFields.length; i++) {
            //         if (customFields[i].name === 'runTime') {
            //             customFields.splice(i, 0, header);
            //             break;
            //         }
            //     }
            // }

            self.set({
                attachedAssetId: attachedAsset.id,
                attachedAssetUuid: attachedAsset.uuid,
                attachedAssetName: attachedAsset.get('name'),
                customFields: customFields,
                location: location,
                locationDescription: locationDescription
            }, options);
        } else {
            self.set({
                attachedAssetId: null,
                attachedAssetUuid: null,
                attachedAssetName: null,
                customFields: customFields,
                location: location,
                locationDescription: locationDescription
            }, options);
        }
    },

    setFromTemplate: function(template, previousTemplate, options) {
        var attributes = _(this.attributes).clone();
        var previousCustomFields = attributes.customFields;
        if (!this.savedCustomFields) this.savedCustomFields = [];
        _(attributes.customFields).each(function (field) {
            var existingField = _(this.savedCustomFields).findWhere({name: field.name});
            if (existingField)
                existingField.value = field.value;
            else
                this.savedCustomFields.push(_(field).clone());
        }, this);
        attributes.customFields = [];
        if (template)
            _(template.customFields).each(function (field) { attributes.customFields.push(_(field).clone()); });
        if (previousCustomFields && attributes.customFields) {
            _(previousCustomFields).each(function (prefield) {
                var tempfield = previousTemplate && _(previousTemplate.customFields).findWhere({name: prefield.name});
                if (tempfield && tempfield.value == prefield.value) return;

                var postfield = _(attributes.customFields).findWhere({name: prefield.name});
                if (!postfield) postfield = _(attributes.customFields).findWhere({label: prefield.label});
                if (postfield) {
                    postfield.value = prefield.value;
                }
            }, this);
        }
        _(this.savedCustomFields).each(function (field) {
            if (!field.value) return;
            var postfield = _(attributes.customFields).findWhere({name: field.name});
            if (!postfield) postfield = _(attributes.customFields).findWhere({label: field.label});
            if (postfield && !postfield.value) postfield.value = field.value;
        }, this);

        if (previousTemplate && attributes.documents) {
            _(previousTemplate.documents).each(function(document) {
                attributes.documents = _(attributes.documents).without(_(attributes.documents).findWhere({contentUrl: document.contentUrl}));
            });
        }
        if (template && template.documents) {
            if (!attributes.documents) {
                attributes.documents = template.documents;
                _(attributes.documents).each(function (document) { delete document.id; delete document.uuid; });
            } else {
                _(template.documents).each(function(document) {
                    if (!_.some((attributes.documents), function(doc) { return doc.contentUrl.split('?')[0] == document.contentUrl; })) {
                        var doc = _(document).clone();
                        delete doc.id; delete doc.uuid;
                        attributes.documents.push(doc);
                    }
                });
            }
        }

        if (template && previousTemplate) {
            if (attributes.state == previousTemplate.state) attributes.state = template.state;
            if (attributes.customerId == previousTemplate.customerId) attributes.customerId = template.customerId;
            if (attributes.customerProjectId == previousTemplate.customerProjectId) attributes.customerProjectId = template.customerProjectId;
            //if (attributes.location.placeName == previousTemplate.location.placeName) attributes.location = _(template.location).clone();
            if (attributes.locationDescription == previousTemplate.description) attributes.locationDescription = template.locationDescription;
            if (attributes.description == previousTemplate.description) attributes.description = template.description;
            if (attributes.stateComment == previousTemplate.stateComment) attributes.stateComment = template.stateComment;
            if (attributes.fuelType == previousTemplate.fuelType) attributes.fuelType = template.fuelType;
            if (attributes.measurementMethod == previousTemplate.measurementMethod) attributes.measurementMethod = template.measurementMethod;
            if (attributes.averageFuelConsumption == previousTemplate.averageFuelConsumption) attributes.averageFuelConsumption = template.averageFuelConsumption;
            if (attributes.environmentalClass == previousTemplate.environmentalClass) attributes.environmentalClass = template.environmentalClass;
        } else if (template) {
            if (!this.id || !attributes.state) attributes.state = template.state;
            if (!attributes.customerId) attributes.customerId = template.customerId;
            if (!attributes.customerProjectId) attributes.customerProjectId = template.customerProjectId;
            if (!attributes.location) attributes.location = template.location;
            if (!attributes.locationDescription) attributes.locationDescription = template.locationDescription;
            if (!attributes.description) attributes.description = template.description;
            if (!attributes.stateComment) attributes.stateComment = template.stateComment;
            if (!attributes.fuelType) attributes.fuelType = template.fuelType;
            if (!attributes.measurementMethod) attributes.measurementMethod = template.measurementMethod;
            if (!attributes.averageFuelConsumption) attributes.averageFuelConsumption = template.averageFuelConsumption;
            if (!attributes.environmentalClass) attributes.environmentalClass = template.environmentalClass;
        }
        if (!attributes.labels) attributes.labels = [];
        if (template && template.labels) {
            _(template.labels).each(function (label) {
                if (attributes.labels.indexOf(label) < 0) attributes.labels.push(label);
            });
        }

        this.set(attributes, options);
    },

    postLocation: function (location) {
        var self = this;
        return $.ajax({
            type: 'POST',
            url: this.url() + '/location',
            contentType: 'application/json',
            data: JSON.stringify(location)
        }).success(function (data) {
            self.set(data);
        });
    },

    geocode: function() {
        this.geocoding = true;
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/location/geocode',
            type: 'POST',
            success: function(data) {
                if (data) self.set('location', data);
            }
        }).complete(function () {
            self.geocoding = false;
        });
    },

    isVehicle: function() {
        if (!this.get('assetTypeId')) return false;
        var assetType = Core.client.assetTypes.get(this.get('assetTypeId'));
        if (!assetType) return false;
        return assetType.get('vehicle');
    },

    occupiedBy: function() {
        var occupant = _(Core.client.users.models).find(function(user) {
            return user && user.get('inVehicleId') == this.get('id');
        }, this);
        if (occupant) return occupant.shortName();
        return null;
    },

    isFavourite: function() {
        return Core.client && Core.client.myFavourites.where({entityUuid: this.get('uuid'), type: 'ASSET'}).length == 1;
    }
});

Core.Assets = Backbone.Collection.extend({
    model: Core.Asset,
    MAX_SEARCH_RESULTS: Core.SEARCH_RESULTS_LIMIT,
    canPaginate: true,
    attachable: false,
    favourites: false,
    url: function() {
        var path = '';
        var params = {};
        if (this.filterParams) {
            params = this.filterParams.params || {};
            if (typeof this.filterParams.path !== 'undefined') path = '/' + this.filterParams.path;
            if (this.filterParams.groups) params.groups = this.filterParams.groups;
            else if (this.filterParams.groupIds) params.groups = this.filterParams.groupIds.join(',');
        }
        if (this.favourites) path = '/myfavourites' + path;
        if (this.filterParams.states) {
            if (typeof this.filterParams.states == 'object')
                params.states = this.filterParams.states.join(',');
            else
                params.states = this.filterParams.states;
        }
        if (this.filterParams.labels) {
            if (typeof this.filterParams.labels == 'object')
                params.labels = this.filterParams.labels.join(',');
            else
                params.labels = this.filterParams.labels;
        }
        if (this.searchQuery) {
            params.q = this.searchQuery;
            path = (this.attachable ? '/attachableassets' : '') + '/search';
            params.limit = this.MAX_SEARCH_RESULTS;
        }
        return Core.Asset.prototype.urlRoot + path + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },
    initialize: function(models, options) {
        this.filterParams = (options && options.filterParams) || {};
        this.favourites = (this.filterParams && this.filterParams.favourites) || false;
    }
});

Core.AssetType = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/asset/type',
    editGroupPermission: 'admin_assets',

    defaults: function() {
        return {
            groupId: Core.client.me.get('primaryGroupId'),
            usableAsObject: true,
            reservable: true
        };
    },

    setFromTemplate: function(template, previous) {
        if (template) {
            this.set({
                vehicle: template.get('vehicle'),
                usableAsResource: template.get('usableAsResource'),
                usableAsObject: template.get('usableAsObject'),
                reservable: template.get('reservable'),
            });
        }
    },

    getOrFetchDetail: function(callback) {
        if (this.get('assetTemplate')) {
            if (callback) callback();
        } else {
            return this.fetch().success(callback);
        }
    },

    destroyIncludingAssets: function() {
        var self = this;
        return $.ajax({
            url: this.url() + (this.url().indexOf('?') >= 0 ? '&' : '?') + 'deleteassets=1',
            type: 'DELETE'
        }).success(function (response) {
            if (self.collection) self.collection.remove(self);
        });
    },

});

Core.AssetTypes = Backbone.Collection.extend({
    model: Core.AssetType,
    url: function() {
        var path = '';
        var params = {};
        if (this.filterParams) {
            params = this.filterParams.params || {};
            if (typeof this.filterParams.path !== 'undefined') path = '/' + this.filterParams.path;
            if (this.filterParams.groupIds) params.groups = this.filterParams.groupIds.join(',');
        }
        if (this.searchQuery) params.q = this.searchQuery;
        return Core.AssetType.prototype.urlRoot + path + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },

    initialize: function(models, options) {
        if (options) this.filterParams = options.filterParams;
    },
});

Core.Assets.filterCollection = function(filter, collection) {
    var filteredCollection = new Core.Assets(collection.models);
    if (collection.searchQuery) return filteredCollection;
    if (filter) {
        if (filter.where)
            filteredCollection = new Core.Assets(filteredCollection.where(filter.where));
        if (filter.states) {
            var states = filter.states;
            filteredCollection = new Core.Assets(filteredCollection.filter(function (asset) {
                var state = asset.get('state');
                if (!state || state == 'INITIAL') state = 'none';
                return states.indexOf(state) >= 0;
            }));
        }
        if (filter.labels) {
            var labels = filter.labels;
            filteredCollection = new Core.Assets(filteredCollection.filter(function (asset) {
                var label = asset.get('labels');
                var match = false;
                if (labels.indexOf("none") >= 0 && (!label || label.length == 0)) match = true;
                label.forEach(function(label) {
                    if (labels.indexOf(label) >= 0) match = true;
                });
                return match;
            }));
        } else {
            filteredCollection = new Core.Assets(filteredCollection.filter(function (asset) {
                return true;
            }));
        }
        if (filter.groups) {
            var groups = filter.groups;
            filteredCollection = new Core.Assets(filteredCollection.filter(function (asset) {
                var groupId = asset.get('groupId');
                return groups === groupId || ($.isArray(groups) && groups.indexOf(groupId) >= 0);
            }));
        } else {
            var activeGroupIds = Core.client.me.getActiveGroupMembershipIds();
            filteredCollection = new Core.Assets(filteredCollection.filter(function (asset) {
                return activeGroupIds.indexOf(asset.get('groupId')) >= 0;
            }));
        }
    }
    return filteredCollection;
};

Core.AssetAvailability = Backbone.Collection.extend({
    initialize: function(options) {
        this.filterParams = {};
        var model = options.reservation || options.job;
        if (options.assetId)
            this.path = options.assetId;
        else if (options.assetTypeId)
            this.path = 'type/' + (options.assetTypeId || 'null');
        else if (model && model.get('assetId'))
            this.path = model.get('assetId');
        else
            console.error('asset availability missing path');
        if (model) {
            this.filterParams.from = model.get('startTime');
            if (model.get('endTime'))
                this.filterParams.to = model.get('endTime');
            else if (model.get('duration') && !model.get('allDay'))
                this.filterParams.to = this.filterParams.from + model.get('duration') * 60000;
            else
                this.filterParams.to = this.filterParams.from;
            if (!this.filterParams.from && this.filterParams.to) this.filterParams.from = this.filterParams.to;
            if (model.get('allDay'))
                this.filterParams.to += 24*3600000;
            this.filterParams.group = model.get('groupId');
            if (model.id) this.filterParams.exclude = model.id;
        } else {
            this.filterParams.from = options.from;
            this.filterParams.to = options.to;
            this.filterParams.group = options.groupId;
        }
    },
    url: function() {
        return Core.contextRoot + '/asset/availability' + (this.path ? '/' + this.path : '') + '?' + $.param(this.filterParams);
    },
});
